const getInnerFragment = (component, xpathEngine) => () => {
    if (!component._innerFragment) {
        component._innerFragment = xpathEngine
            .evaluateXPath(
                component.innerFragmentPath,
                { context: component.fragmentContainer },
            )
            .first();
    }

    return component._innerFragment;
}

function nodeContentComponent(xpathEngine, componentType) {
    let component = {
        component: componentType,
    };

    component.getInnerFragment = getInnerFragment(component, xpathEngine);

    return component;
}

export default nodeContentComponent;